<template>
  <div class="luxury-layout">
    <el-container style="height:100vh; background: #f8f9fa;">
      <!-- 顶部导航栏 - 简约风格 -->
      <el-header class="luxury-header">
        <div class="header-content">
          <div class="brand-area">
            <img src="@/assets/logo.png" alt="系统标志" class="brand-logo">
            <span class="brand-name">XXXX管理系统</span>
          </div>

          <div class="user-controls">
            <el-dropdown placement="bottom-end" trigger="hover">
              <div class="user-profile">
                <el-avatar :size="36" :src="user.avatar" class="user-avatar"></el-avatar>
                <div class="user-details">
                  <span class="user-name">{{ user.nickname }}</span>
                  <span class="user-role">{{ user.role }}</span>
                </div>
                <i class="el-icon-arrow-down"></i>
              </div>
              <el-dropdown-menu slot="dropdown" class="profile-menu">
                <el-dropdown-item v-for="item in dropdown" :key="item.id" @click.native="command(item)"
                  class="menu-item">
                  <i :class="['icon', item.icon]"></i>
                  <span>{{ item.name }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-header>

      <!-- 主体内容区 -->
      <el-container>
        <!-- 侧边栏 - 简约风格 -->
        <Siderbar class="luxury-sidebar" />

        <!-- 主内容区 -->
        <el-main class="luxury-main">
          <div class="content-container">
            <router-view />
          </div>
        </el-main>
      </el-container>
    </el-container>
    <ChangePwd @close="close" @submit="subChangePwd" :loading="loading" :dialogFormVisible="dialogFormVisible" />
  </div>
</template>

<script>
import { changePassword, logout } from '@/api/login';
import Siderbar from './Siderbar.vue'
import { Loading, Message } from 'element-ui';
import ChangePwd from './ChangePwd.vue';

export default {
  components: {
    Siderbar, ChangePwd
  },
  data() {
    return {
      dialogFormVisible: false,
      loading: false,
      user: JSON.parse(localStorage.getItem('user')),
      dropdown: [
        {
          id: 3, name: '修改密码', icon: 'el-icon-edit', fn: this.changePwd
        },
        {
          id: 4, name: '退出登录', icon: 'el-icon-switch-button', fn: this.logout
        }
      ]
    }
  },
  methods: {
    command(item) {
      // 处理菜单项点击
      console.log(item);
      item.fn && item.fn()
    },
    logout() {
      logout().then(() => {
        Message.success('退出登陆')
        localStorage.clear();
        this.$router.replace('/')
      })
    },
    changePwd() {
      this.dialogFormVisible = true;
    },
    close() {
      this.dialogFormVisible = false;
    },
    subChangePwd(params) {
      this.loading = true;
      changePassword(params).then(res => {
        Message.success(res.msg || '密码修改成功，请重新登录');
        this.loading = false;
        this.logout();
      }).catch(err => {
        this.loading = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu{
  width: 200px;
}
.luxury-layout {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Arial', sans-serif;
  color: #333;



  .luxury-header {
    height: 64px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    z-index: 10;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      padding: 0 24px;
      margin: 0 auto;
    }

    .brand-area {
      display: flex;
      align-items: center;

      .brand-logo {
        height: 32px;
        margin-right: 12px;
      }

      .brand-name {
        font-size: 18px;
        font-weight: 500;
        color: #333;
        letter-spacing: 0.5px;
      }
    }

    .user-controls {
      .user-profile {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: rgba(0, 0, 0, 0.02);
        }

        .user-avatar {
          margin-right: 12px;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .user-details {
          display: flex;
          flex-direction: column;
          margin-right: 12px;

          .user-name {
            font-size: 14px;
            font-weight: 500;
            color: #333;
          }

          .user-role {
            font-size: 12px;
            color: #888;
            margin-top: 2px;
          }
        }
      }
    }
  }

  .luxury-sidebar {
    background: #fff;
    box-shadow: 1px 0 10px rgba(0, 0, 0, 0.03);
    border-right: 1px solid rgba(0, 0, 0, 0.05);
  }

  .luxury-main {
    padding: 12px;
    box-sizing: border-box;
    background: #f8f9fa;

    .content-container {
      background: #fff;
      border-radius: 8px;
      min-height: calc(100vh - 88px);
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.03);
    }
  }

  .profile-menu {
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 8px 0;

    .menu-item {
      padding: 10px 20px;
      font-size: 13px;
      color: #555;
      transition: all 0.2s;

      &:hover {
        background: #f8f9fa;
        color: #333;
      }

      .icon {
        margin-right: 10px;
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>